var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIneFrontIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 44,
    viewBox: "0 0 80 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 44,
    rx: 8.18182,
    fill: "#F0F0EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.42857C0 3.32589 3.32589 0 7.42857 0H72.5714C76.6741 0 80 3.32589 80 7.42857L78.9302 7.61701C52.8155 12.2169 26.0924 12.1531 0 7.42857Z",
    fill: "#95908D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.57129,
    y: 14.8572,
    width: 24.5714,
    height: 24.5714,
    rx: 2.33766,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.7144,
    y: 28.8792,
    width: 24.1161,
    height: 2.24189,
    rx: 1.12095,
    fill: "#95908D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33.7144,
    y: 32.5996,
    width: 41.7143,
    height: 2.54661,
    rx: 1.27331,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33.7144,
    y: 36.3542,
    width: 41.7143,
    height: 2.54661,
    rx: 1.27331,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33.7144,
    y: 15.4285,
    width: 15.8262,
    height: 2.24189,
    rx: 1.12095,
    fill: "#95908D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 33.7144,
    y: 19.1492,
    width: 27.375,
    height: 2.54661,
    rx: 1.27331,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 33.7144,
    y: 22.9038,
    width: 27.375,
    height: 2.54661,
    rx: 1.27331,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIneFrontIcon);
export default __webpack_public_path__ + "static/media/ineFrontIcon.00d5f006aed10302e83eed5c1831e522.svg";
export { ForwardRef as ReactComponent };